import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
//#endregion
//#region components
import { useGenericDocumentService } from "serviceHooks";
import GenericDocumentUploadForm from "./uploadGenericForm";
//#endregion
import * as Yup from "yup";

const UploadGenericFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const genericDocumentService = useGenericDocumentService();
  const genericFile = {
    comment: "",
    files: [],
  } as DocumentFormTypes.UploadGenericDocument;

  const validationSchema = Yup.object<DocumentFormTypes.UploadGenericDocument>({
    files: Yup.array()
      .of(
        Yup.object<UploadedFile>({
          contentType: Yup.string(),
          fileName: Yup.string(),
          fileSize: Yup.number(),
          data: Yup.string(),
        })
      )
      .required(TranslationKeys.Validations.Required),
    comment: Yup.string(),
  });

  const handleFormSubmit = (values: DocumentFormTypes.UploadGenericDocument) => {
    return genericDocumentService.create({
      subject: values.comment,
      images: values.files.map((f) => ({ contentType: f.contentType, imageData: f.data, name: f.fileName })),
    });
  };

  return (
    <GenericDocumentUploadForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={genericFile}
      handleSubmit={handleFormSubmit}
    />
  );
};

export default forwardRef(UploadGenericFormContainer);
